import "../CSS/itemEvento.css";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import React, { useRef, useEffect, useState, Fragment } from "react";

function InfoEvento(props) {
  const [fecha, setFecha] = useState(
    new Date(props.fecha.toString()).getDate() +
      " de " +
      getMonthName(new Date(props.fecha.toString()).getMonth() + 1) +
      " del " +
      new Date(props.fecha.toString()).getFullYear()
  );
  const [hola, setHola] = useState("Hola");
  function getMonthName(monthNumber) {
    if (monthNumber) {
      const date = new Date();
      date.setMonth(monthNumber - 1);

      const formatter = new Intl.DateTimeFormat("es-pe", { month: "long" });

      return formatter.format(date);
    }
  }
  return (
    <div className="evento-card">
      <div>
        <img
          id="imagenTienda"
          className="evento-logoEmpresa"
          src={props.imagen}
          alt="flecha"
        />
      </div>
      <div className="itemBody">
        <div className="evento-cabecera">
          <p>{props.nombre}</p>
          <p>Fecha: {fecha}</p>
		  <p>Hora : {props.hora}</p>
          <p>{props.descripcion}</p>
        </div>
      </div>
    </div>
  );
}

export default InfoEvento;
